// FIXME: Remove this file when migrating all channels js to /javascript/channels
import { createConsumer } from '@rails/actioncable'

// Pages that don't render the action-cable-url meta tag (e.g. the meeting room) still
// import this consumer; guard the lookup so a missing tag doesn't throw and abort the
// whole Stimulus controller chain. createConsumer(undefined) falls back to its default mount path.
export default createConsumer(document.querySelector('meta[name=action-cable-url]')?.getAttribute('content'));